import { Injectable } from '@angular/core';

import * as fromCoreStore from '@abovo/webvis-data-access';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';

@Injectable()
export class WebvisGuard {
   constructor(private store: Store<fromCoreStore.CoreState>) {}

   canActivate() {
      this.store.dispatch(new fromCoreStore.LoadDrawerSettings());
      return of(true);
   }
}
